import React, { useContext, useRef } from 'react'
import { DrillThruTableConetext } from '../DrillThru'
import PropTypes from 'prop-types'
import { CopyIcon } from '../../../GenericComponents/copyIcon'
import { decodeHtml } from '../../../Utils';

function DrillThruTableRowDisplay(props: any) {
    const DrillThruTableConetextValues = useContext(DrillThruTableConetext);
        const {
            draggedColIndex,
            setDraggedColIndex
        } = DrillThruTableConetextValues;
        const isDimmed = draggedColIndex !== null && draggedColIndex !== props.colCounter;
    const linkRef = useRef<HTMLAnchorElement>(null);
    const content = props.valText; //FP-12118- Already passing empty from parent compoennt no need extra check props.valText || '-'
    const decodedContent = decodeHtml(content);
    const hasHTML = /<\/?[a-z][\s\S]*>/i.test(decodedContent);
    const handleLinkClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        if (props.onClick) {
            props.onClick(event);
        }
        if (linkRef.current) {
            linkRef.current.style.color = '#e17009';
            linkRef.current.style.textDecoration = 'none';
        }
    };
    return (
        <>
            <td
                className={`left ${isDimmed ? 'dimmed-column' : ''}`}
                ref={props.cellRef}
                data-column-name={props.headerText}
                style={{
                    ...(props.colCounter === 0
                        ? { position: 'sticky', left: '0px', zIndex: 4 }
                        : props.colCounter === 1
                            ? { position: 'sticky', left: `${props.firstColumnWidth}px`, zIndex: 3 }
                            : {}),
                }}
                key={props.headerText}>
                {/* for above td need to apply position sticky */}
                {props.isLink ? (
                    <a
                        // onContextMenu={linkProps.onContextMenu}
                        href={props.href}
                        id={props.id}
                        ref={linkRef}
                        // title={linkProps.title}
                        onContextMenu={(e) => {if(props.onContextMenu !== undefined) props.onContextMenu(e)}}
                        onClick={handleLinkClick}
                    // style={{ ...(linkProps.style as {}), color: linkColor }}
                    >
                        {props.valText}
                    </a>
                ) : hasHTML ? (
                    <span
                        id={props.id}
                        style={{ minWidth: 'auto', maxWidth: 'none', whiteSpace: 'inherit' }}
                        dangerouslySetInnerHTML={{ __html: decodedContent }}
                    />
                ) : (
                    <span
                        id={props.id}
                        style={{ minWidth: 'auto', maxWidth: 'none', whiteSpace: 'inherit' }}
                    >
                        {props.valText}
                    </span>
                )}
                {
                    props.valText && //FP-12118- does not require copy icon if no text
                    <span>
                        <CopyIcon copyText={Object.values(props.valText).join('')} id={''} />
                        {' '}
                    </span>
                }
            </td>
        </>
    )
}

DrillThruTableRowDisplay.propTypes = {
    headerText: PropTypes.string.isRequired,
    id: PropTypes.string,
    href: PropTypes.string,
    isLink: PropTypes.bool,
    onClick: PropTypes.func,
    valText: PropTypes.string.isRequired,
    firstColumnWidth: PropTypes.number,
    colCounter: PropTypes.number,
    cellRef: PropTypes.object,
    onContextMenu: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {}
}

export default DrillThruTableRowDisplay
